import React from 'react';
import PropTypes from 'prop-types';
import * as NuacomScreens from '~/screens';
import { DialogContext, DialogContainer } from './styles';

function DetailsModal(props) {
  const { open } = props;

  return (
    <DialogContainer
      disableEnforceFocus
      // Note: This Id is used to control scroll across the sub-components
      aria-labelledby="call-details-modal-container"
      aria-describedby="call-details-modal-container"
      open={open || false}
      PaperProps={{
        style: {
          margin: 0,
        },
      }}
      BackdropProps={{
        invisible: true,
        root: {
          position: 'absolute',
        },
      }}
      style={{
        position: 'absolute',
        elevation: 1,
        zIndex: 900,
        top: -90,
      }}>
      <DialogContext>
        {open && <NuacomScreens.CallDetails {...props} />}
      </DialogContext>
    </DialogContainer>
  );
}

DetailsModal.defaultProps = {
  open: false,
  setOpen: () => {},
};

DetailsModal.propTypes = {
  open: PropTypes.bool,
  setOpen: PropTypes.func,
};

export default DetailsModal;
